import React, { FC } from 'react';
import { css, cx } from 'linaria';
import { getStoreDetail } from 'features/store/ducks/get-store-by-id';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';

type Props = {
  className?: string;
};

export const NearestSubway: FC<Props> = ({ className }) => {
  const { nearestSubwayStation = '' } = useSelector(getStoreDetail) || {};
  return (
    <div className={cx(className, metroContainer)} data-qa="metro-info">
      {nearestSubwayStation.split(', ').map((item) => (
        <Typography variant="caption" color="text-minor" key={item} className={metroItem}>
          {item.split(' (').join(' — ').split(')').join('')}
        </Typography>
      ))}
    </div>
  );
};

const metroContainer = css`
  display: flex;
  flex-direction: column;
`;

const metroItem = css`
  margin-bottom: var(--space-100);
`;
